module.exports = __webpack_public_path__ + "static/media/TSDS.f5df91b1.avif";